import { DisplayTypes } from 'shared/constants/FlowConstants';
import showAndGridFactory from 'shared/data/showAndGridFactory';

export default showAndGridFactory(DisplayTypes.list);
